var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sustainability",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sustainability---Home",
    transform: "translate(-1055.000000, -1134.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flexible-Content-Block",
    transform: "translate(0.000000, 673.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Resource-Card",
    transform: "translate(738.000000, 440.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download-Icon",
    transform: "translate(318.000000, 21.000000)",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.500000, 9.000000) rotate(-270.000000) translate(-8.500000, -9.000000) translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.582060928,
    y1: 5.7833999,
    x2: 15.192056,
    y2: 5.7833999,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.872456,
    y1: 5.7153599,
    x2: 10.5953361,
    y2: 0.438240051,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.872456,
    y1: 11.1585598,
    x2: 10.5953361,
    y2: 5.88143996,
    id: "Line-2",
    transform: "translate(13.267800, 8.505000) rotate(-90.000000) translate(-13.267800, -8.505000) "
  })), /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 20,
    x2: 0,
    y2: 20,
    id: "Line-3"
  }))))))));
};
export { SvgDownload as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjEiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZyBpZD0iU3VzdGFpbmFiaWxpdHkiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJTdXN0YWluYWJpbGl0eS0tLUhvbWUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMDU1LjAwMDAwMCwgLTExMzQuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSJGbGV4aWJsZS1Db250ZW50LUJsb2NrIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgNjczLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IlJlc291cmNlLUNhcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDczOC4wMDAwMDAsIDQ0MC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iRG93bmxvYWQtSWNvbiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzE4LjAwMDAwMCwgMjEuMDAwMDAwKSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDguNTAwMDAwLCA5LjAwMDAwMCkgcm90YXRlKC0yNzAuMDAwMDAwKSB0cmFuc2xhdGUoLTguNTAwMDAwLCAtOS4wMDAwMDApIHRyYW5zbGF0ZSgwLjAwMDAwMCwgMy4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxsaW5lIHgxPSIwLjU4MjA2MDkyOCIgeTE9IjUuNzgzMzk5OSIgeDI9IjE1LjE5MjA1NiIgeTI9IjUuNzgzMzk5OSIgaWQ9IkxpbmUiPjwvbGluZT4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxsaW5lIHgxPSIxNS44NzI0NTYiIHkxPSI1LjcxNTM1OTkiIHgyPSIxMC41OTUzMzYxIiB5Mj0iMC40MzgyNDAwNTEiIGlkPSJMaW5lLTIiPjwvbGluZT4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxsaW5lIHgxPSIxNS44NzI0NTYiIHkxPSIxMS4xNTg1NTk4IiB4Mj0iMTAuNTk1MzM2MSIgeTI9IjUuODgxNDM5OTYiIGlkPSJMaW5lLTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzLjI2NzgwMCwgOC41MDUwMDApIHJvdGF0ZSgtOTAuMDAwMDAwKSB0cmFuc2xhdGUoLTEzLjI2NzgwMCwgLTguNTA1MDAwKSAiPjwvbGluZT4KICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgICAgICA8bGluZSB4MT0iMTcuNSIgeTE9IjIwIiB4Mj0iMCIgeTI9IjIwIiBpZD0iTGluZS0zIj48L2xpbmU+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";